export const hadleFilter = (codProd) => {
  const otrosProductos = [
    {
      value: "todas",
      lable: "Todas",
    },
    {
      value: "revision",
      lable: "Revision",
    },
    {
      value: "firmado",
      lable: "Firmado",
    },
    {
      value: "porFirmar",
      lable: "Por firmar",
    },
    {
      value: "pendiente",
      lable: "Pendientes",
    },
    {
      value: "emitida",
      lable: "Emitidas",
    },
    {
      value: "rechazada",
      lable: "Rechazadas",
    },
    {
      value: "errPago",
      lable: "Error de pago",
    },
    {
      value: "vencida",
      lable: "Vencidas",
    },
    {
      value: "enFila",
      lable: "En fila",
    },
    {
      value: "errEmitida",
      lable: "Error al emitir",
    },
  ];
  const inversionGlobal = [
    {
      value: "todas",
      lable: "Todas",
    },
    {
      value: "revision",
      lable: "Revision",
    },
    {
      value: "firmado",
      lable: "Firmado",
    },
    {
      value: "porFirmar",
      lable: "Por firmar",
    },
    {
      value: "pendiente",
      lable: "Pendientes",
    },
    {
      value: "emitida",
      lable: "Emitidas",
    },
    {
      value: "rechazada",
      lable: "Rechazadas",
    },
    {
      value: "errPago",
      lable: "Error de pago",
    },
    {
      value: "vencida",
      lable: "Vencidas",
    },
    {
      value: "enFila",
      lable: "En fila",
    },
    {
      value: "errEmitida",
      lable: "Error al emitir",
    },
    {
      value: "suscrita",
      lable: "Suscrita",
    },
  ];
  const rentasVitalicias = [
    {
      value: "todas",
      lable: "Todas",
    },
    {
      value: "ingresado",
      lable: "Ingresado",
    },
    {
      value: "ingresadoRp",
      lable: "Ingresado RP",
    },
    {
      value: "cotizado",
      lable: "Cotizado",
    },
    {
      value: "mejorado",
      lable: "Mejorado",
    },
    {
      value: "enviadoMeller",
      lable: "Enviado Meller",
    },
    {
      value: "ganado",
      lable: "Ganado",
    },
    {
      value: "perdido",
      lable: "Perdido",
    },
    {
      value: "recalculado",
      lable: "Recalculado",
    },
    {
      value: "emitida",
      lable: "Emitida",
    },
    {
      value: "cartaEnviada",
      lable: "Carta Enviada",
    },
    {
      value: "datosActualizados",
      lable: "Datos Actualizados",
    },
    {
      value: "enviadoEmision",
      lable: "Enviado Emisión",
    },
    {
      value: "errorEmitir",
      lable: "Error al emitir",
    },
    {
      value: "anulado",
      lable: "Anulado",
    }
  ]

  const stateFilter =
    codProd === "IG"
      ? inversionGlobal
      : codProd === "RV"
      ? rentasVitalicias
      : otrosProductos;
  return stateFilter;
};